const sortByLastFirst = (a, b) => {
  if (a.last === b.last) {
    return a.first < b.first ? -1 : 0;
  } else {
    return a.last < b.last ? -1 : 0;
  }
};

export default sortByLastFirst;
